import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/inventory/analytics")({
  component: AnalyticsPlaceholder,
});

function AnalyticsPlaceholder() {
  return (
    <div className="container mx-auto px-4 py-6 space-y-6">
      <h1 className="text-2xl font-bold">Inventory Analytics</h1>
      <p className="text-muted-foreground">Coming soon...</p>
    </div>
  );
}
